import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { ScopingHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';

export class ScopingDetailsResolver implements Resolver {
  async resolve(): Promise<void> {
    const [projectBundleID] = getProjectBundleIDParamFromUrl();

    await HttpService.getHttpRequests(ScopingHttpService).getScopingSummary(
      projectBundleID,
    );
  }
}
